<template>
  <div class="ecn-map" @touchmove.stop @touch.stop>
    <div class="close" @click.stop="close"><i class="el-icon-close"></i></div>
    <div id="amap-mobile-container" class="map-container"></div>
    <div class="address" @click.stop="openAMap">
      <div class="address-info">
        <div>陕西医智诺集团</div>
        <div>陕西省西安市高新区天谷八路156号西安软件新城研发基地二期C2栋14层1401室</div>
      </div>
      <div class="address-icon">
        <img src="../../assets/image/Mobile/navigation.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lng: 108.835123, lat: 34.206827 },
      zoom: 20,
      mapLink: 'https://uri.amap.com/marker?position=108.835123,34.206827&name=陕西医智诺信息科技有限公司&src=www.echartnow.com&coordinate=gaode&callnative=1',
      map: null
    }
  },
  mounted() {
    this.initAMap();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initAMap() {
      this.map = new AMap.Map('amap-mobile-container', {
        center: [108.835123,34.206827],
        zoom: 20,
        resizeEnable: true,
        scrollWheel: true
      });
      const marker = new AMap.Marker({
        position: [108.835123,34.206827],
        title: '陕西医智诺集团'
      });
      const infoWindow = new AMap.InfoWindow({
          content: `
              <div style="padding: 10px; color: #333; font-size: 14px;">
                  <div><strong>陕西医智诺集团</strong></div>
                  <div>陕西省西安市高新区天谷八路156号西安软件新城研发基地二期C2栋14层1401室</div>
              </div>
          `,
          offset: new AMap.Pixel(0, -30)
      });
      marker.on('click', () => {
          infoWindow.open(this.map, marker.getPosition());
      });
      this.map.add(marker);
      infoWindow.open(this.map, marker.getPosition());
    },
    getClickInfo(e) {
      this.center.lng = e.lnglat.lng;
      this.center.lat = e.lnglat.lat;
    },
    openAMap() {
      location.href = this.mapLink;
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.ecn-map{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 10000;
}
.close{
  font-size: 70px;
  color: #333;
  position: fixed;
  top: 40px;
  right: 40px;
  z-index: 10005;
}
.map-container {
  width: 100%;
  height: 100vh;
  // transform: scale(2, 2);
}
.address{
  width: 100%;
  height: 315px;
  background-color: #fff;
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 10005;
  .address-info{
    color: #0A0D10;
    width: calc(100% - 300px);
    padding: 52px 0 52px 36px;
    &>div:first-child{
      font-size: 48px;
      line-height: 100px;
      font-weight: 700;
    }
    &>div:last-child{
      font-size: 36px;
    }
  }
  .address-icon {
    width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 120px;
      height: 120px;
    }
  }
}
</style>